/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import Grid from '../../../../../SharedModules/Table/tableGrid';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import { NDC_LABELER_DRUG_TABLEHAD } from '../../utility/tableHeads';
import NDCColumnCustomComponent from '../NDCColumnCustomComponent';

const LabelerDrugTable = ({
  labelerRow,
  labelerDrugTableData,
  setDrugTableRow,
  setGridApi,
  gridApi,
  fullScreen,
  setFullScreen,
}) => {
  const childRef = useRef(null);
  const [columnApi, setColumnApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);
  const [applyFilter, setApplyFilter] = useState(false);
  const [total, setTotal] = useState(0);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, labelerDrugTableData]);

  const onSelectionChanged = useCallback(() => {
    setDrugTableRow(gridApi.getSelectedRows());
  }, [gridApi]);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };

  return (
    <>
      <TableFilterHeader
        gridApi={gridApi}
        columnApi={columnApi}
        childRef={childRef}
        applyFilter={applyFilter}
        showFullScreen
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        showHistory={false}
        showExport
        fileName="Labeler NDC"
        resetFilterFunc={resetFilters}
        className="mt-2 mb-1 border-bottom"
      />
      <div className="table-container eightRecords">
        <Grid
          ref={childRef}
          gridHeight={fullScreen ? '100vh' : 350}
          rowData={labelerDrugTableData}
          columnDefs={NDC_LABELER_DRUG_TABLEHAD}
          defaultCol={{ editable: false }}
          onGridReady={onGridReady}
          rowSelection="multiple"
          setTotal={setTotal}
          onSelectionChanged={onSelectionChanged}
          frameworkComponents={{
            ndcLabelerComponent: NDCColumnCustomComponent,
            nameRenderNdcDrugName: (cellInfo) => {
              const name = cellInfo.data && cellInfo.data.drugName;
              if (name && name.length > 18) {
                return (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                  >
                    <div>{name}</div>
                  </OverlayTrigger>
                );
              }
              return <div>{name}</div>;
            },
          }}
          onFilterChanged={(e) => {
            setTableCount(e.api.getDisplayedRowCount());
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
        />
        <p className="total-results" tabIndex="0">
          Total Results: <b>{tableCount?.toLocaleString('en-US')}</b>
        </p>
      </div>
    </>
  );
};

export default LabelerDrugTable;
